var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, ModalBody, ModalFoot, ModalHead } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';
import { analytics } from 'app/utils/segment';
import HoldMusicWithPlayer from './holdMusicContainer';
import styles from './holdMusicModal.module.scss';
export default class HoldMusicModal extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            waitMusicLabelError: '',
            waitMusicValidateClasses: '',
            selectedAudio: null,
        };
    }
    onClose() {
        analytics.phoneChangeHoldMusicFormCancelled();
        this.props.onClose();
    }
    saveClickHandler() {
        analytics.phoneChangeHoldMusicFormSubmitted();
        const { selectedAudio } = this.state;
        const { orgId, onClose, editOrganization } = this.props;
        onClose();
        editOrganization(orgId, {
            updates: {
                default_hold_music_id: selectedAudio === null || selectedAudio === void 0 ? void 0 : selectedAudio.id,
            },
        });
    }
    updateAudio({ selectedAudio }) {
        this.setState({
            waitMusicLabelError: '',
            waitMusicValidateClasses: '',
            selectedAudio,
        });
    }
    render() {
        const { waitMusicLabelError, waitMusicValidateClasses } = this.state;
        const { onClose, isOpen } = this.props;
        return (_jsxs(Modal, Object.assign({ className: styles.modal, isOpen: isOpen, onClose: onClose }, { children: [_jsx(ModalHead, { title: "Hold music", onClose: onClose }), _jsx(ModalBody, { children: _jsx(HoldMusicWithPlayer, { onSelectedCallback: this.updateAudio, labelError: waitMusicLabelError, className: waitMusicValidateClasses }) }), _jsx(ModalFoot, { cancelOnClick: this.onClose, confirmName: "Save", confirmOnClick: this.saveClickHandler })] })));
    }
}
__decorate([
    boundMethod
], HoldMusicModal.prototype, "onClose", null);
__decorate([
    boundMethod
], HoldMusicModal.prototype, "saveClickHandler", null);
__decorate([
    boundMethod
], HoldMusicModal.prototype, "updateAudio", null);
